import { render, staticRenderFns } from "./FrzChamberPickingViewDetail.vue?vue&type=template&id=4ae249fa"
import script from "./FrzChamberPickingViewDetail.vue?vue&type=script&lang=js"
export * from "./FrzChamberPickingViewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports